<div class="col-md-12" style="margin-left: -125px">
    <div class="tab-pane" role="tabpanel" id="formulario19">
        <fieldset id="agregar_formulario19" class="">
            <div class="container" id="center_div">
                <div class="row">
                    <div class="col-md-12">
                        <div id='page1' class="contenedorFormulario print-wrap page1">
                            <div>
                                <span style="float: right; clear: right;">(S.R.E.A. - 5.1.4)</span> Formulario 1.9
                                <span style="float: right; clear: right;">1/3</span>
                            </div>
                            <h1><strong>SOLICITUD DE REGULARIZACION DE OBRA MENOR</strong></h1>
                            <h2><strong>(Permiso y Recepcion definitiva)</strong></h2>
                            <h1><strong>EDIFICACION ANTIGUA DE CUALQUIER DESTINO</strong></h1>
                            <h2><strong>(Construida con anterioridad al 31 de Julio de 1959)</strong></h2>
                            <br />
                            <div class="row">
                                <div class="col-md-4">
                                    &nbsp;
                                </div>
                                <div class="col-md-4">
                                    <h2 class="infObligatorios">
                                        <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                    <h2 class="infObligatorios"> {{region}} </h2>
                                    <table class="tablaConBorde">
                                        <tr>
                                            <td>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'urbano'" [checked]="propiedad[0].ubicacion == 'URBANO'" />
                                                <label for="tpradio">URBANO</label>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'rural'" [checked]="propiedad[0].ubicacion == 'RURAL'" />
                                                <label for="tpradio">RURAL</label>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-md-4">
                                    <table style="float: right; clear: right; width: 140px;" class="tablaConBorde table">
                                        <tbody>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    N&Uacute;MERO SOLICITUD
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">
                                                    <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    Fecha de Ingreso
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td class="letraChica">
                                                    * A LLENAR POR LA D.O.M
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                            <br />
                            <div>
                                <table style="width: 100%;" class="tablaConBorde table">

                                    <tr class="rd_tipo">
                                        <td class="fondoResaltado izquierda" rowspan="2" style="width: 40%">
                                            CERTIFICADO DE INFORMACIONES PREVIAS:

                                        </td>
                                        <td class="fondoResaltado">
                                            N&uacute;mero
                                        </td>
                                        <td class="fondoResaltado">
                                            Fecha
                                        </td>

                                    </tr>
                                    <tr class="rd_tipo">
                                        <td>
                                            <input disabled class="form-control" type="text" name="certcip" id="certcip" [(ngModel)]="cip[0].certcip" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" type="text" name="fecha_cip" id="fecha_cip" [(ngModel)]="cip[0].fecha_cip" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span> 1.- DIRECCI&Oacute;N DE LA PROPIEDAD</span>
                                    <span class="help-block"></span>
                                </div>
                                <table style="width: 100%" border="0" class="tablaConBorde table">
                                    <tr class="fondoResaltado">
                                        <td style="width: 57%" colspan="3">
                                            CALLE O CAMINO
                                        </td>
                                        <td style="width: 24%">
                                            N&Uacute;MERO
                                        </td>
                                        <td style="width: 19%">
                                            ROL SII
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="propiedad[0].calle" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="numero" name="numero" type="text" [(ngModel)]="propiedad[0].calle_num" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rol" name="rol" type="text" [(ngModel)]="propiedad[0].rol" />
                                        </td>

                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td style="width: 11%">
                                            MANZANA
                                        </td>
                                        <td style="width: 10%">
                                            LOTE
                                        </td>
                                        <td style="width: 61%" colspan="2">
                                            LOTEO O LOCALIDAD
                                        </td>
                                        <td style="width: 18%">
                                            PLANO DE LOTEO N°
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="manzana" name="manzana" type="text" [(ngModel)]="propiedad[0].manzana" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" name="lote" id="lote" type="text" [(ngModel)]="propiedad[0].lote" />
                                        </td>
                                        <td colspan="2">
                                            <input disabled class="form-control" id="localidad" name="localidad" type="text" [(ngModel)]="propiedad[0].localidad" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="loteo_numero" name="loteo_numero" type="text" [(ngModel)]="propiedad[0].loteo_numero" />
                                        </td>
                                    </tr>
                                </table>

                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>2.- DECLARACION JURADA</span>
                                    <span class="help-block"></span>
                                </div>

                                <table style="width: 100%;" class="tablaConBordeExterno table">
                                    <tr>
                                        <td colspan="7"><input disabled class="form-control" id="nombre" name="nombre" type="text" [(ngModel)]="propietarios[0].nombre" /></td>
                                        <td align="right" colspan="4"><span>C&Eacute;DULA DE</span></td>

                                    </tr>
                                    <tr>
                                        <td align="left"><span>IDENTIDAD Nº</span></td>
                                        <td colspan="5"><input disabled class="form-control" id="rut" name="rut" type="text" [(ngModel)]="propietarios[0].rut" /></td>
                                        <td colspan="5" align="right"><span>DECLARA BAJO SU RESPONSABILIDAD</span></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span> SER</span></td>
                                        <td align="left"><span>PROPIETARIO</span></td>
                                        <td colspan="3" align="center"><span>(O  REPRESENTANTE  LEGAL  DEL  PROPIETARIO)</span> </td>
                                        <td colspan="2"><span>DEL  BIEN  RAIZ</span></td>
                                        <td align="left" colspan="4"><span>UBICADO  EN  CALLE/ </span></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span>/AVENIDA/CAMINO</span></td>
                                        <td align="right" colspan="3"><input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="propietarios[0].direccion" /></td>
                                        <td align="left" colspan="3"><span>NUMERO:</span> </td>
                                        <td align="left" colspan="4"><input disabled class="form-control" id="numero" name="numero" type="text" [(ngModel)]="propietarios[0].direccion_num" /></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span>ROL DE AVALUO Nº</span></td>
                                        <td align="right" colspan="2"><input disabled class="form-control" id="rol" name="rol" type="text" [(ngModel)]="propiedad[0].rol" /></td>
                                        <td align="left"> <span>DE LA COMUNA DE </span></td>
                                        <td align="right" colspan="7"><input disabled class="form-control" id="comuna" name="comuna" [(ngModel)]="propietarios[0].comuna" type="text" /></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" align="left"><span>QUE SE ENCUENTRA INSCRITO A FOJAS</span></td>
                                        <td align="right"><input disabled class="form-control" id="inscripcion" name="inscripcion" type="text" [(ngModel)]="registro_bienes[0].inscrito" /></td>
                                        <td align="center"><span>N°</span></td>
                                        <td align="right" colspan="2"><input disabled class="form-control" id="num_insc" name="num_insc" type="text" [(ngModel)]="registro_bienes[0].numero" /></td>
                                        <td align="center"><span>AÑO</span></td>
                                        <td align="right"><input disabled class="form-control" id="anio_insc" name="anio_insc" type="text" [(ngModel)]="registro_bienes[0].anio" /></td>
                                        <td colspan="3" align="left"><span>DEL REGISTRO</span></td>
                                    </tr>
                                    <tr>
                                        <td align="left">DE PROPIEDAD</td>
                                        <td colspan="2" align="left"> DEL CONSERVADOR</td>
                                        <td align="left"> DE BIENES </td>
                                        <td align="left"> RAÍCES DE</td>
                                        <td align="left" colspan="6"><input disabled class="form-control" id="raices" name="raices" type="text" [(ngModel)]="registro_bienes[0].bienes" /></td>

                                    </tr>
                                    <tr>
                                        <td align="left">EN EL CUAL</td>
                                        <td align="left">SE EMPLAZA</td>
                                        <td colspan="2" align="left"><span>EL PROYECTO</span></td>
                                        <td align="left"><span>PARA EL QUE SE</span></td>
                                        <td colspan="6" align="left"><span>PRESENTA ESTA SOLICITUD</span></td>

                                    </tr>

                                </table>

                                <div class="letraChica"><span>NOTA: DE EXISTIR DOS O MÁS PROPIETARIOS, Y/O DOS O MÁS BIENES RAÍCES SE DEBERÁ ACOMPAÑAR HOJA ADJUNTA CON LOS DATOS Y FIRMAS CORRESPONDIENTE (*) SOLO EN LA EVENTUALIDAD QUE SE ACOMPAÑE DICHO PLANO.</span></div>

                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>3.- DATOS DEL PROPIETARIO</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%">
                                            NOMBRE DEL PROPIETARIO
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                        <td>
                                            FIRMA DEL PROPIETARIO
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <input disabled class="form-control" readonly id="nombre_prop" name="nombre_prop" type="text" [(ngModel)]="propietarios[0].nombre" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rut_prop" name="rut_prop" type="text" [(ngModel)]="propietarios[0].rut" />
                                        </td>
                                        <td rowspan="7">

                                        </td>

                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%">
                                            REPRESENTANTE LEGAL
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><input disabled class="form-control" readonly id="nombre_rep" name="nombre_rep" type="text" [(ngModel)]="representantes[0].nombre" /></td>
                                        <td><input disabled class="form-control" id="rut_rep" name="rut_rep" type="text" [(ngModel)]="representantes[0].rut" /></td>
                                    </tr>

                                    <tr class="fondoResaltado">
                                        <td style="width: 25%">
                                            DIRECCI&Oacute;N / CALLE / PASAJE
                                        </td>
                                        <td style="width: 25%">
                                            N°
                                        </td>
                                        <td style="width: 25%">
                                            COMUNA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="propietarios[0].direccion" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="propietarios[0].direccion_num" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="propietarios[0].comuna" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td>
                                            E-MAIL
                                        </td>
                                        <td>
                                            TEL&Eacute;FONO
                                        </td>
                                        <td>
                                            FAX
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="email_prop" name="email_prop" type="email" [(ngModel)]="propietarios[0].mail" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="tel_prop" name="tel_prop" type="text" [(ngModel)]="propietarios[0].fono" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fax_prop" name="fax_prop" type="text" [(ngModel)]="propietarios[0].fax" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado tablaConBordeExterno table">
                                        <td colspan="4">
                                            PERSONERIA DEL REPRESENTANTE LEGAL
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            SE ACREDITA MEDIANTE
                                        </td>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="acredita" name="acredita" type="text" [(ngModel)]="permiso_notariado[0].acreditacion" />
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            DE FECHA
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fecha_acr" name="fecha_acr" type="text" [(ngModel)]="permiso_notariado[0].fecha" />
                                        </td>
                                        <td>
                                            Y REDUCIDA A ESCRITURA PUBLICA CON FECHA
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fecha_esc" name="fecha_esc" type="text" [(ngModel)]="permiso_notariado[0].escritura" />
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            ANTE EL NOTARIO SR(A)
                                        </td>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="notario" name="notario" type="text" [(ngModel)]="permiso_notariado[0].notario" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>4.- ARQUITECTO PROYECTISTA</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%"><span>
                                            NOMBRE O RAZON SOCIAL DE LA EMPRESA</span><span class="letraChica">(cuando corresponda)</span>
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                        <td>
                                            FIRMA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <input disabled class="form-control" readonly id="nombre_emp" name="nombre_emp" type="text" [(ngModel)]="empresas[0].nombre" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rut_emp" name="rut_emp" type="text" [(ngModel)]="empresas[0].rut" />
                                        </td>
                                        <td rowspan="5"></td>

                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%">
                                            NOMBRE ARQUITECTO
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><input disabled class="form-control" readonly id="nombre_arq" name="nombre_arq" type="text" [(ngModel)]="arquitectos[0].nombre" /></td>
                                        <td><input disabled class="form-control" id="rut_arq" name="rut_arq" type="text" [(ngModel)]="arquitectos[0].rut" /></td>
                                    </tr>

                                    <tr class="fondoResaltado">
                                        <td style="width: 25%">
                                            DIRECCI&Oacute;N / CALLE / PASAJE
                                        </td>
                                        <td style="width: 25%">
                                            N°
                                        </td>
                                        <td style="width: 25%">
                                            COMUNA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="arquitectos[0].direccion" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="arquitectos[0].direccion_num" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="arquitectos[0].comuna" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td>
                                            E-MAIL
                                        </td>
                                        <td>
                                            TEL&Eacute;FONO
                                        </td>
                                        <td>
                                            FAX
                                        </td>
                                        <td>
                                            PATENTE PROFESIONAL N°
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="email_arq" name="email_arq" type="email" [(ngModel)]="arquitectos[0].mail" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="tel_arq" name="tel_arq" type="text" [(ngModel)]="arquitectos[0].fono" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fax_arq" name="fax_arq" type="text" [(ngModel)]="arquitectos[0].fax" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="pat_arq" name="pat_arq" type="text" [(ngModel)]="arquitectos[0].patente" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <br />
                            <br />
                            <br />
                            <br />
                        </div>
                        <div id='page2' class="contenedorFormulario print-wrap page2">
                            <div>
                                <span style="float: right; clear: right;">(S.R.E.A. - 5.1.4)</span> Formulario 1.9
                                <span style="float: right; clear: right;">2/3</span>
                            </div>
                            <br />
                            <div>
                                <div class="tituloSeccion">
                                    <span>5.- PROFESIONAL COMPETENTE QUE INFORMA CUMPLIMIENTO DE NORMAS DE ESTABILIDAD</span>
                                    <span class="help-block letraChica">(si ocurre)</span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%"><span>
                                                NOMBRE O RAZON SOCIAL DE LA EMPRESA</span><span class="letraChica"> (cuando corresponsa)</span>
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                        <td>
                                            FIRMA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <input disabled class="form-control" readonly id="nombre_constra" name="nombre_constra" type="text" [(ngModel)]="constructora[0].nombre" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rut_constra" name="rut_constra" type="text" [(ngModel)]="constructora[0].rut" />
                                        </td>
                                        <td rowspan="5"></td>

                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%">
                                            <span>NOMBRE DEL PROFESIONAL COMPETENTE</span><span class="letraChica">(Arquitecto o Ingeniero Civil)</span>
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><input disabled class="form-control" readonly id="nombre_const" name="nombre_const" type="text" [(ngModel)]="constructores[0].nombre" /></td>
                                        <td><input disabled class="form-control" id="rut_const" name="rut_const" type="text" [(ngModel)]="constructores[0].rut" /></td>
                                    </tr>

                                    <tr class="fondoResaltado">
                                        <td style="width: 25%">
                                            DIRECCI&Oacute;N / CALLE / PASAJE
                                        </td>
                                        <td style="width: 25%">
                                            N°
                                        </td>
                                        <td style="width: 25%">
                                            COMUNA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="constructores[0].direccion" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="constructores[0].direccion_num" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="constructores[0].comuna" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td>
                                            E-MAIL
                                        </td>
                                        <td>
                                            TEL&Eacute;FONO
                                        </td>
                                        <td>
                                            FAX
                                        </td>
                                        <td>
                                            PATENTE PROFESIONAL N°
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="email_const" name="email_const" type="email" [(ngModel)]="constructores[0].mail" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="tel_const" name="tel_const" type="text" [(ngModel)]="constructores[0].fono" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fax_const" name="fax_const" type="text" [(ngModel)]="constructores[0].fax" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="pat_const" name="pat_const" type="text" [(ngModel)]="constructora[0].patente" />
                                        </td>
                                    </tr>
                                </table>
                                <div class="letraChica"><span>* Profesional que podr&aacute; individualizarse hasta antes del inicio de las obras</span></div>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>6.- ANTECEDENTES DE LA EDIFICACION QUE SE REGULARIZA</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td style="width: 50%" align="left">SOLICITUD TRATA DE LA REGULACION DE TODA LA EDIFICACION ANTIGUA</td>
                                        <td style="width: 25%"><span><input type="checkbox" class="form-check-inline" readonly id="edificacion_antigua" name="edificacion_antigua" value="SI" [checked]="antecedentes_edif[0].edificacion_antigua == 'SI'"/>SI</span></td>
                                        <td style="width: 25%"><span><input type="checkbox" class="form-check-inline" readonly id="edificacion_antigua" name="edificacion_antigua" value="SI" [checked]="antecedentes_edif[0].edificacion_antigua == 'NO'"/>NO</span></td>

                                    </tr>
                                </table>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td style="width: 50%" align="left">SOLICITUD TRATA DE LA REGULACION DE UNA AMPLIACION ANTIGUA</td>
                                        <td style="width: 25%"><span><input type="checkbox" class="form-check-inline" readonly id="ampliacion_antigua" name="ampliacion_antigua" value="SI" [checked]="antecedentes_edif[0].ampliacion_antigua == 'SI'"/>SI</span></td>
                                        <td style="width: 25%"><span><input type="checkbox" class="form-check-inline" readonly id="ampliacion_antigua" name="ampliacion_antigua" value="SI" [checked]="antecedentes_edif[0].ampliacion_antigua == 'NO'"/>NO</span></td>

                                    </tr>
                                </table>

                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td style="width: 25%">DESTINO PRINCIPAL DE LA EDIFICACION</td>
                                        <td style="width: 25%">SUP. TOTAL A REGULARIZAR</td>
                                        <td style="width: 25%">SUP. TERRENO</td>
                                        <td style="width: 25%">N° PISOS SOBRE N.M</td>
                                    </tr>
                                    <tr>
                                        <td><input disabled class="form-control" readonly id="destino" name="destino" type="text" [(ngModel)]="antecedentes_edif[0].destino" /></td>
                                        <td><input disabled class="form-control" readonly id="superf_total" name="superf_total" type="text" [(ngModel)]="antecedentes_edif[0].superf_total" /></td>
                                        <td><input disabled class="form-control" readonly id="superf_terreno" name="superf_terreno" type="text" [(ngModel)]="antecedentes_edif[0].superf_terreno" /></td>
                                        <td><input disabled class="form-control" readonly id="npisos" name="npisos" type="text" [(ngModel)]="antecedentes_edif[0].npisos" /></td>
                                    </tr>
                                </table>


                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>7.- SUPERFICIE A REGULARIZAR</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td colspan="2"></td>
                                        <td>UTIL (m2)</td>
                                        <td>COMUN (m2)</td>
                                        <td>TOTAL (m2)</td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td colspan="2" align="left">SUP. EDIFICADA BAJO TERRENO</td>
                                        <td><input disabled class="form-control" readonly id="util1" name="util1" type="text" [(ngModel)]="superficie[0].util1" /></td>
                                        <td><input disabled class="form-control" readonly id="comun1" name="comun1" type="text" [(ngModel)]="superficie[0].comun1" /></td>
                                        <td><input disabled class="form-control" readonly id="total1" name="total1" type="text" [(ngModel)]="superficie[0].total1" /></td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td colspan="2" align="left">SUP. EDIFICADA SOBRE TERRENO</td>
                                        <td><input disabled class="form-control" readonly id="util2" name="util2" type="text" [(ngModel)]="superficie[0].util2" /></td>
                                        <td><input disabled class="form-control" readonly id="comun2" name="comun2" type="text" [(ngModel)]="superficie[0].comun2" /></td>
                                        <td><input disabled class="form-control" readonly id="total2" name="total2" type="text" [(ngModel)]="superficie[0].total2" /></td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td colspan="2" align="left">SUP. EDIFICADA TOTAL</td>
                                        <td><input disabled class="form-control" readonly id="util3" name="util3" type="text" [(ngModel)]="superficie[0].util3" /></td>
                                        <td><input disabled class="form-control" readonly id="comun3" name="comun3" type="text" [(ngModel)]="superficie[0].comun3" /></td>
                                        <td><input disabled class="form-control" readonly id="total3" name="total3" type="text" [(ngModel)]="superficie[0].total3" /></td>
                                    </tr>

                                </table>
                                <br />
                                <table class="tablaConBorde table form-group">
                                    <tr>
                                        <td class="fondoResaltado" colspan="6"></td>
                                    </tr>
                                    <tr>
                                        <td>1er. Piso</td>
                                        <td><input disabled class="form-control" style="text-align: right" readonly id="piso1" value="m2" name="piso1" type="text" [(ngModel)]="superficie[0].piso1" /></td>
                                        <td>6° Piso</td>
                                        <td><input disabled class="form-control" style="text-align: right" readonly id="piso6" value="m2" name="piso6" type="text" [(ngModel)]="superficie[0].piso6" /></td>
                                        <td>11° Piso</td>
                                        <td><input disabled class="form-control" style="text-align: right" readonly id="piso11" value="m2" name="piso11" type="text" [(ngModel)]="superficie[0].piso11" /></td>
                                    </tr>
                                    <tr>
                                        <td>2° Piso</td>
                                        <td><input disabled class="form-control" style="text-align: right" readonly id="piso2" value="m2" name="piso2" type="text" [(ngModel)]="superficie[0].piso2" /></td>
                                        <td>7° Piso</td>
                                        <td><input disabled class="form-control" style="text-align: right" readonly id="piso7" value="m2" name="piso7" type="text" [(ngModel)]="superficie[0].piso7" /></td>
                                        <td>12° Piso</td>
                                        <td><input disabled class="form-control" style="text-align: right" readonly id="piso12" value="m2" name="piso12" type="text" [(ngModel)]="superficie[0].piso12" /></td>
                                    </tr>
                                    <tr>
                                        <td>3° Piso</td>
                                        <td><input disabled class="form-control" style="text-align: right" readonly id="piso3" value="m2" name="piso3" type="text" [(ngModel)]="superficie[0].piso3" /></td>
                                        <td>8° Piso</td>
                                        <td><input disabled class="form-control" style="text-align: right" readonly id="piso8" value="m2" name="piso8" type="text" [(ngModel)]="superficie[0].piso8" /></td>
                                        <td>13° Piso</td>
                                        <td><input disabled class="form-control" style="text-align: right" readonly id="piso13" value="m2" name="piso13" type="text" [(ngModel)]="superficie[0].piso13" /></td>
                                    </tr>
                                    <tr>
                                        <td>4° Piso</td>
                                        <td><input disabled class="form-control" style="text-align: right" readonly id="piso4" value="m2" name="piso4" type="text" [(ngModel)]="superficie[0].piso4" /></td>
                                        <td>9° Piso</td>
                                        <td><input disabled class="form-control" style="text-align: right" readonly id="piso9" value="m2" name="piso9" type="text" [(ngModel)]="superficie[0].piso9" /></td>
                                        <td>14° Piso</td>
                                        <td><input disabled class="form-control" style="text-align: right" readonly id="piso14" value="m2" name="piso14" type="text" [(ngModel)]="superficie[0].piso14" /></td>
                                    </tr>
                                    <tr>
                                        <td>5° Piso</td>
                                        <td><input disabled class="form-control" style="text-align: right" readonly id="piso5" value="m2" name="piso5" type="text" [(ngModel)]="superficie[0].piso5" /></td>
                                        <td>10° Piso</td>
                                        <td><input disabled class="form-control" style="text-align: right" readonly id="piso10" value="m2" name="piso10" type="text" [(ngModel)]="superficie[0].piso10" /></td>
                                        <td>15° Piso</td>
                                        <td><input disabled class="form-control" style="text-align: right" readonly id="piso15" value="m2" name="piso15" type="text" [(ngModel)]="superficie[0].piso15" /></td>
                                    </tr>
                                </table>
                                <span class="letraChica">En caso de contemplar la Regulaci&oacute;n de m&aacute;s pisos, adjuntar hoja complementaria</span>
                                <br />
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>8.- NUMERO DE UNIDADES TOTALES POR DESTINO</span><span class="letraChica">(EN CASO DE ARTICULOS 121,122,123 O 124 DE LA LGUC)</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td class="fondoResaltado">VIVIENDA</td>
                                        <td><input disabled class="form-control" style="text-align: right" readonly id="vivienda" value="m2" name="vivienda" type="text" [(ngModel)]="unidades[0].vivienda" /></td>
                                        <td class="fondoResaltado">OFICINAS</td>
                                        <td><input disabled class="form-control" style="text-align: right" readonly id="oficinas" value="m2" name="oficinas" type="text" [(ngModel)]="unidades[0].oficinas" /></td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado">LOCALES COMERCIALES</td>
                                        <td><input disabled class="form-control" style="text-align: right" readonly id="locales" value="m2" name="locales" type="text" [(ngModel)]="unidades[0].locales" /></td>
                                        <td class="fondoResaltado">ESTACIONAMIENTOS</td>
                                        <td><input disabled class="form-control" style="text-align: right" readonly id="estacionamientos" value="m2" name="estacionamientos" type="text" [(ngModel)]="unidades[0].estacionamientos" /></td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado">Otros</td>
                                        <td colspan="3"><input disabled class="form-control" style="text-align: right" readonly id="otros" value="m2" name="otros" type="text" [(ngModel)]="unidades[0].otros" /></td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>9.- PERMISOS Y RECEPCIONES ANTERIORES (En caso de tratarse de Ampliaciones Construidas antes de 31/07/1959)</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado" style="height: 30px;">
                                        <td style="width: 25%">PERMISO PRIMITIVO</td>
                                        <td style="width: 15%">N°</td>
                                        <td style="width: 15%">FECHA</td>
                                        <td style="width: 15%">SUPERFICIE M2</td>
                                        <td style="width: 15%">RECEPCION N°</td>
                                        <td style="width: 15%">FECHA</td>
                                    </tr>
                                    <tr *ngFor="let permiso of perm">
                                        <td><input disabled class="form-control" readonly id="permiso_prim" name="permiso_prim" type="text" [(ngModel)]="permiso.permiso" /></td>
                                        <td><input disabled class="form-control" readonly id="permiso_num" name="permiso_num" type="text" [(ngModel)]="permiso.numero" /></td>
                                        <td><input disabled class="form-control" readonly id="permiso_fecha" name="permiso_fecha" type="text" [(ngModel)]="permiso.fecha" /></td>
                                        <td><input disabled class="form-control" readonly id="superficie" name="superficie" type="text" [(ngModel)]="permiso.superficie" /></td>
                                        <td><input disabled class="form-control" readonly id="recepcion" name="recepcion" type="text" [(ngModel)]="permiso.recepcion" /></td>
                                        <td><input disabled class="form-control" readonly id="fecha_recep" name="fecha_recep" type="text" [(ngModel)]="permiso.fecha_recep" /></td>
                                    </tr>
                                    <tr class="fondoResaltado" style="height: 30px;">
                                        <td style="width: 25%">AMPLIACIONES</td>
                                        <td style="width: 15%">N°</td>
                                        <td style="width: 15%">FECHA</td>
                                        <td style="width: 15%">SUPERFICIE M2</td>
                                        <td style="width: 15%">RECEPCION N°</td>
                                        <td style="width: 15%">FECHA</td>
                                    </tr>
                                    <tr *ngFor="let recepcion of recep">
                                        <td><input disabled class="form-control" readonly id="modif_prim1" name="modif_prim1" type="text" [(ngModel)]="recepcion.permiso" /></td>
                                        <td><input disabled class="form-control" readonly id="modif_num1" name="modif_num1" type="text" [(ngModel)]="recepcion.numero" /></td>
                                        <td><input disabled class="form-control" readonly id="modif_fecha1" name="modif_fecha1" type="text" [(ngModel)]="recepcion.fecha" /></td>
                                        <td><input disabled class="form-control" readonly id="modif_sup1" name="modif_sup1" type="text" [(ngModel)]="recepcion.superficie" /></td>
                                        <td><input disabled class="form-control" readonly id="mod_recep1" name="mod_recep1" type="text" [(ngModel)]="recepcion.recepcion" /></td>
                                        <td><input disabled class="form-control" readonly id="mod_fecha_recep1" name="mod_fecha_recep1" type="text" [(ngModel)]="recepcion.fecha_recep" /></td>
                                    </tr>

                                </table>
                                <br />


                            </div>
                            <br />
                            <div>
                                <div class="tituloSeccion">
                                    <span>10.- CLASIFICACION(ES) CONSTRUCCION(ES) PREDOMINANTE(S)</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td>CLASIFICACION</td>
                                        <td>m2</td>
                                        <td>CLASIFICACION</td>
                                        <td>m2</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" readonly id="clasificacion1" name="clasificacion1" type="text" *ngIf="!clasificacion[0]" />
                                            <input disabled class="form-control" readonly id="clasificacion1" name="clasificacion1" type="text" [(ngModel)]="clasificacion[0].clasificacion" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="clasificacion1" name="clasificacion1" type="text" *ngIf="!clasificacion[0]" />
                                            <input disabled class="form-control" readonly id="metro1" name="metro1" type="text" [(ngModel)]="clasificacion[0].metro" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="clasificacion1" name="clasificacion1" type="text" *ngIf="!clasificacion[1]" />
                                            <input disabled class="form-control" readonly id="clasif1" name="clasif1" type="text" *ngIf="clasificacion[1]" [(ngModel)]="clasificacion[1].clasificacion" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="clasificacion1" name="clasificacion1" type="text" *ngIf="!clasificacion[1]" />
                                            <input disabled class="form-control" readonly id="met1" name="met1" type="text" *ngIf="clasificacion[1]" [(ngModel)]="clasificacion[1].metro" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" readonly id="clasificacion1" name="clasificacion1" type="text" *ngIf="!clasificacion[2]" />
                                            <input disabled class="form-control" readonly id="clasificacion2" name="clasificacion2" type="text" *ngIf="clasificacion[2]" [(ngModel)]="clasificacion[2].clasificacion" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="clasificacion1" name="clasificacion1" type="text" *ngIf="!clasificacion[2]" />
                                            <input disabled class="form-control" readonly id="metro2" name="metro2" type="text" *ngIf="clasificacion[2]" [(ngModel)]="clasificacion[2].metro" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="clasificacion1" name="clasificacion1" type="text" *ngIf="!clasificacion[3]" />
                                            <input disabled class="form-control" readonly id="clasif2" name="clasif2" type="text" *ngIf="clasificacion[3]" [(ngModel)]="clasificacion[3].clasificacion" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="clasificacion1" name="clasificacion1" type="text" *ngIf="!clasificacion[3]" />
                                            <input disabled class="form-control" readonly id="met2" name="met2" type="text" *ngIf="clasificacion[3]" [(ngModel)]="clasificacion[3].metro" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" readonly id="clasificacion1" name="clasificacion1" type="text" *ngIf="!clasificacion[4]" />
                                            <input disabled class="form-control" readonly id="clasificacion3" name="clasificacion3" type="text" *ngIf="clasificacion[4]" [(ngModel)]="clasificacion[4].clasificacion" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="clasificacion1" name="clasificacion1" type="text" *ngIf="!clasificacion[4]" />
                                            <input disabled class="form-control" readonly id="metro3" name="metro3" type="text" *ngIf="clasificacion[4]" [(ngModel)]="clasificacion[4].metro" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="clasificacion1" name="clasificacion1" type="text" *ngIf="!clasificacion[5]" />
                                            <input disabled class="form-control" readonly id="clasif3" name="clasif3" type="text" *ngIf="clasificacion[5]" [(ngModel)]="clasificacion[5].clasificacion" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="clasificacion1" name="clasificacion1" type="text" *ngIf="!clasificacion[5]" />
                                            <input disabled class="form-control" readonly id="met3" name="met3" type="text" *ngIf="clasificacion[5]" [(ngModel)]="clasificacion[5].metro" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <br />
                            <div>
                                <div class="tituloSeccion">
                                    <span>11.- DISPOSICIONES ESPECIALES A LAS QUE SE ACOGERA LA EDIFICACION A REGULAR</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td align="center" style="background: white; vertical-align: middle; width: 3%"><input type="checkbox" disabled class="form-check-inline" readonly id="disposicion1" name="disposicion1" value="ART 55 LGUC" [checked]="disposicion[0].disposicion1" /></td>
                                        <td style="vertical-align: middle"><span>ART 55 LGUC</span></td>
                                        <td align="center" style="background: white; vertical-align: middle; width: 3%"><input type="checkbox" disabled class="form-check-inline" readonly id="disposicion2" name="disposicion2" value="LEY 17.288 MONUMENTOS NACIONALES" [checked]="disposicion[0].disposicion2" /></td>
                                        <td style="vertical-align: middle"><span>LEY 17.288 MONUMENTOS NACIONALES</span></td>
                                        <td align="center" style="background: white; vertical-align: middle; width: 3%"><input type="checkbox" disabled class="form-check-inline" readonly id="disposicion3" name="disposicion3" value="LEY N° 19.537 COPROPIEDAD INMOBILIARIA" [checked]="disposicion[0].disposicion3" /></td>
                                        <td style="vertical-align: middle"><span>LEY N° 19.537 COPROPIEDAD INMOBILIARIA</span></td>
                                        <td align="center" style="background: white; vertical-align: middle; width: 3%"><input type="checkbox" disabled class="form-check-inline" readonly id="disposicion4" name="disposicion4" value="OTRO" [checked]="disposicion[0].disposicion4" /></td>
                                        <td style="vertical-align: middle"><span>OTRO</span></td>
                                    </tr>
                                </table>
                            </div>
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                        </div>
                        <div id='page3' class="contenedorFormulario print-wrap page3">
                            <div>
                                <span style="float: right; clear: right;">(S.R.E.A. - 5.1.4)</span> Formulario 1.9
                                <span style="float: right; clear: right;">3/3</span>
                            </div>
                            <br />
                            <div>
                                <div class="tituloSeccion">
                                    <span>12.- ANTECEDENTES QUE SE ADJUNTAN</span>
                                    <span class="help-block"></span>
                                    <span class="letraChica">(ART. 5.1.4/1.4.2/1.2.1. OGUC)</span>
                                </div>

                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td style="width: 3%">DOM</td>
                                        <td colspan="2"></td>
                                        <td style="width: 3%">DOM</td>
                                        <td colspan="2"></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td align="center" style="width: 3%; vertical-align: middle"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td style="vertical-align: middle"><span>Listado de documentos y planos numerados</span></td>
                                        <td></td>
                                        <td align="center" style="width: 3%; vertical-align: middle"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td style="vertical-align: middle"><span>Informe del Arquitecto que certifique forma en que la edificación a
                                                regularizar cumple con las normas técnicas de habilitabilidad y
                                                seguridad, con las normas técnicas de estabilidad y con las de
                                                instalaciones interiores de electricidad, y cuando corresponda, de
                                                agua potable, alcantarillado y gas, establecidas por los Organismos
                                                competentes.</span></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td align="center" style="vertical-align: middle"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td style="vertical-align: middle"><span>Fotocopia Certificado de Informaciones Previas</span></td>
                                        <td></td>
                                        <td align="center" style="vertical-align: middle"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                        <td style="vertical-align: middle"><span>Informe complementario sobre cumplimiento de las normas de
                                                estabilidad, suscrito por profesional arquitecto o ingeniero civil, (si
                                                concurre).</span></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td align="center" style="vertical-align: middle"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                        <td style="vertical-align: middle"><span>Fotocopia patente al día del arquitecto que suscribe la solicitud y los
                                                demás antecedentes y de otros profesionales competentes que concurren
                                                en la solicitud de regularización (si corresponde)</span></td>
                                        <td></td>
                                        <td align="center" style="vertical-align: middle"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                        <td style="vertical-align: middle"><span>Certificado de dotación de servicios sanitarios, instalaciones
                                                eléctricas interiores y de gas, cuando proceda.</span></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td align="center" style="vertical-align: middle"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td style="vertical-align: middle"><span>Formulario Único de Estadísticas de Edificación</span></td>
                                        <td></td>
                                        <td align="center" style="vertical-align: middle"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                        <td style="vertical-align: middle"><span>Declaración de instalaciones eléctricas de ascensores y montacargas
                                                inscrita por instaladas autorizado en la SEC (cuando
                                                corresponda)</span></td>
                                    </tr>



                                    <tr>
                                        <td></td>
                                        <td align="center" style="vertical-align: middle"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                        <td style="vertical-align: middle"><span>Acuerdo de los copropietarios en los términos previstos en la Ley N° 19.537
                                                    en caso que edificación que se regulariza se emplace en un condominio (si
                                                    corresponde)</span></td>
                                        <td></td>
                                        <td align="center" style="vertical-align: middle"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td style="vertical-align: middle"><span>Croquis de emplazamiento a escala, en que se grafique edificación a
                                                    regularizar; en caso de ampliación graficar además edificación que
                                                    cuenta con permiso y recepción</span></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td align="center" style="vertical-align: middle"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                        <td style="vertical-align: middle"><span>Autorización del Consejo de Monumentos Nacionales en caso que la
                                                        edificación a regularizar trate de un Monumento Nacional</span></td>
                                        <td></td>
                                        <td align="center" style="vertical-align: middle"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td style="vertical-align: middle"><span>Plano de planta general y elevaciones a escala 1:50 con cotas,
                                                        individualización de recintos y cuadro de superficies.</span></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td align="center" style="vertical-align: middle"></td>
                                        <td><span></span></td>
                                        <td></td>
                                        <td align="center" style="vertical-align: middle"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled></td>
                                        <td style="vertical-align: middle"><span>Especificaciones Técnicas resumidas señalando las partidas más
                                                            relevantes de la edificación.</span></td>
                                    </tr>
                                </table>


                            </div>
                            <br />
                            <div>
                                <div class="tituloSeccion">
                                    <span>13.- DERECHOS MUNICIPALES </span><span class="letraChica"> (A LLENAR POR LA D.O.M)</span>
                                    <span class="help-block"></span>
                                </div>

                                <table class="tablaConBorde table form-group">
                                    <tr>
                                        <td>PRESUPUESTO DE OBRA</td>
                                        <td> <input disabled class="form-control" readonly id="presupuesto" name="presupuesto" type="text" value="$" /></td>
                                        <td>MONTO DE DERECHOS MUNICIPALES</td>
                                        <td> <input disabled class="form-control" readonly id="monto" name="monto" type="text" value="$" /></td>
                                    </tr>
                                    <tr>
                                        <td>PORCENTAJE A CONSIGNAR</td>
                                        <td align="right"><input disabled class="form-control" readonly id="giro" name="giro" type="text" value="%" /></td>
                                        <td>MONTO</td>
                                        <td><input disabled class="form-control" readonly id="giro" name="giro" type="text" value="$" /></td>
                                    </tr>
                                    <tr>
                                        <td>GIRO INGRESO MUNICIPAL N°</td>
                                        <td><input disabled class="form-control" readonly id="giro" name="giro" type="text" /></td>
                                        <td>DE FECHA</td>
                                        <td><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" /></td>
                                    </tr>
                                </table>
                            </div>
                            <br />
                            <br />
                            <div class="tablaConBordeExterno">
                                <span>NOTA </span><span class="letraChica">( PARA SITUACIONES ESPECIALES )</span>
                                <span><input disabled class="form-control" readonly id="nota" name="nota" type="textarea" /></span>
                            </div>
                            <div>
                                <br />
                                <br />
                                <br />
                                <hr />
                                <br />
                                <br />
                            </div>
                            <div>
                                <div><span style="float: right; clear: right;">(S.R.E.A. - 5.1.4)</span></div>
                                <div>
                                    <h1><strong>COMPROBANTE DE INGRESO</strong></h1>
                                </div>
                            </div>
                            <br />
                            <br />
                            <div>
                                <table class="tablaConBorde izquierda">
                                    <tr>
                                        <td class="fondoResaltado">MONTO CONSIGNADO AL INGRESO</td>
                                        <td><input disabled class="form-control" readonly id="monto" name="monto" type="text" value="$" /></td>
                                        <td class="fondoResaltado">GIM N°</td>
                                        <td><input disabled class="form-control" readonly id="gim" name="gim" type="text" /></td>
                                        <td class="fondoResaltado">FECHA</td>
                                        <td><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" /></td>
                                    </tr>
                                </table>
                            </div>
                            <br />
                            <div class="row">
                                <div class="col-md-4">
                                    <table class="tablaConBordeExterno">
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr align="center">
                                            <td>FIRMA FUNCIONARIO.</td>
                                        </tr>
                                        <tr align="center">
                                            <td> Y TIMBRE D.O.M.</td>
                                        </tr>

                                    </table>

                                </div>
                                <br />
                                <div class="col-md-4">
                                    <h2 class="infObligatorios">
                                        <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                    <h2 class="infObligatorios"> {{region}} </h2>
                                </div>
                                <div class="col-md-4">
                                    <table style="float: right; clear: right; width: 140px;" class="tablaConBorde table">
                                        <tbody>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    N&Uacute;MERO SOLICITUD
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">
                                                    <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    Fecha de Ingreso
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                            <br />
                            <div>
                                <table class="tablaConBorde">
                                    <tr class="fondoResaltado">
                                        <td>CALLE O CAMINO</td>
                                        <td>N&Uacute;MERO</td>
                                    </tr>
                                    <tr>
                                        <td><input class="form-control" type="text" id="calle" name="calle" disabled [(ngModel)]="propiedad[0].calle" /></td>
                                        <td><input class="form-control" type="text" id="numero" name="numero" disabled [(ngModel)]="propiedad[0].calle_num" /></td>
                                    </tr>
                                </table>
                            </div>
                            <hr />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <button mat-raised-button color="primary" id="pdf-download-link" title="Descargar Formulario 1.9" (click)="captureScreen()">Descargar Formulario 1.9</button>
            </div>
        </fieldset>
    </div>
</div>